import { Menu } from "Components/menuGeneric";
import React, { useEffect, useState } from "react";
import buildProfileMenuItems from "./profileMenuItems/buildProfileMenuItems";
import ProfileToggler from "./profileToggler";
export default function Profile(props) {
    const [menuItems, setMenuItems] = useState([]);
    useEffect(() => {
        setMenuItems(buildProfileMenuItems());
    }, []);
    return (React.createElement(Menu, { className: props.className, zIndex: props.zIndex, menuToggler: ProfileToggler, menuItems: menuItems, container: document.body }));
}
